
import * as _ from "lodash";
import * as codes from "./define/codes";



/** */
export type ProjectInfo = {
    /** プロジェクトID*/
    ProjectId: number;
    /** プロジェクトcode*/
    ProjectCode: string;
    /** 顧客ID*/
    CustomerId: number;
    /** 工場ID*/
    FactoryId: number;
    /** プロジェクト管理番号*/
    ProjectManageNo: string;
    /** プロジェクト名*/
    ProjectName: string;
    /** 開始年月日*/
    ProjectStartDate: Date;
    /** 終了年月日*/
    ProjectEndDate: Date;
    /** プラントGr列数*/
    PlantGroupColumnNumber: number;
    /** box使用区分*/
    BoxUseDiv: string;
    /** バックアップ有無フラグ*/
    BackupFlg: boolean;
    /** 誤入力警報表示フラグ */
    WrongWordWarningFlg: boolean;
    /** お知らせ表示フラグ */
    NoticeFlg: boolean;
    /** 前日実績入力締切時間 */
    PrevDateResultInputCutOffTime: Date;
    /** 集計基準日区分 */
    AggregateTargetDateDiv: string;

    //#4347
    /** パスワード有効期限*/
    PasswordExpireDays: number;

    /** 2要素認証フラグ */
    TwoFactorAuthenticationFlg: boolean;

    //#5906
    /** 未来進捗反映フラグ */
    FutureProgressInfoMergeEnableFlg: boolean;

    //#6215
    /** 出力帳票ID */
    ExportFileId: string;
    /** 予定変更ボタン表示フラグ */
    DirectReHoldFlg: boolean;
    /** 進捗履歴予定日開始日数*/
    ProgressHistoryFromDays: number;
    /** 進捗履歴予定日終了日数*/
    ProgressHistoryToDays: number;

    ///** 顧客名*/
    //CustomerNm: string;
    ///** 工場名*/
    //FactoryNm: string;

    /** 有効フラグ */
    EnableFlg: boolean;

}



/**
 * 業務共通処理ユーティリティ
 */
export class Project {

    /***/
    private static projectInfoData: ProjectInfo;

    /**
     * projectInfo
     * @param event
     */
    static get projectInfo(): ProjectInfo {
        try {
            if (!Project.projectInfoData) {
                const _projectInfoRaw = $('#_projectInfo').val() + '';
                const _projectInfoObject = JSON.parse(_projectInfoRaw);
                Project.setProjectInfo(_projectInfoObject);
            }
        } catch (e) {
            //noop
        }
        return Project.projectInfoData;
    }

    /**
     * projectInfo
     * @param event
     */
    static setProjectInfo(_projectInfoObject) {
        //_.assignIn(Session.projectInfoData, _projectInfoObject);
        Project.projectInfoData = _projectInfoObject;
    }


    /**
     * 選択予定日リストを返す
     */
    static getScheduledDateList() {
        const from = new Date(new Date().toDateString());
        const to = new Date(Project.projectInfo.ProjectEndDate);
        const r = [];
        const start = new Date(from);
        const end = new Date(to);
        for (let d = start; d <= end; d.setDate(d.getDate() + 1)) {
            r.push(new Date(d));
        }
        return r;
    }


}
